import React from 'react';
import { Megaphone, Link as LinkIcon } from 'lucide-react';
export const AnnouncementSection = () => {
  const announcements = [{
    id: 1,
    title: 'Circular for annual leaves',
    icon: <Megaphone className="h-5 w-5 text-white" data-id="element-14" />
  }, {
    id: 2,
    title: 'Assigning Ms Hiba Ali...',
    icon: <Megaphone className="h-5 w-5 text-white" data-id="element-15" />
  }, {
    id: 3,
    title: 'Assigning Mrs. Noura...',
    icon: <Megaphone className="h-5 w-5 text-white" data-id="element-16" />
  }, {
    id: 4,
    title: 'Assigning Eng.Shikha Ali...',
    icon: <Megaphone className="h-5 w-5 text-white" data-id="element-17" />
  }, {
    id: 5,
    title: 'Assigning Ms.Nawal Alnaqbi',
    icon: <Megaphone className="h-5 w-5 text-white" data-id="element-18" />
  }, {
    id: 6,
    title: 'Pursuing undergraduate an...',
    icon: <Megaphone className="h-5 w-5 text-white" data-id="element-19" />
  }];
  return <div data-id="element-20">
      <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-21">Announcements</h2>
      <div className="grid grid-cols-3 gap-4" data-id="element-22">
        {announcements.map(announcement => <div key={announcement.id} className="bg-white rounded-lg shadow-sm p-4 flex items-center space-x-4" data-id="element-23">
            <div className="bg-purple-500 h-12 w-12 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-24">
              {announcement.icon}
            </div>
            <div className="flex-1 min-w-0" data-id="element-25">
              <p className="text-sm font-medium text-gray-700 truncate" data-id="element-26">
                {announcement.title}
              </p>
              <p className="text-xs text-gray-500" data-id="element-27">.</p>
            </div>
            <LinkIcon className="h-5 w-5 text-blue-500 flex-shrink-0" data-id="element-28" />
          </div>)}
      </div>
      <div className="flex justify-end mt-4" data-id="element-29">
        <button className="p-2 rounded-full bg-gray-100 text-gray-500" data-id="element-30">
          <ChevronRight className="h-5 w-5" data-id="element-31" />
        </button>
      </div>
    </div>;
};
const ChevronRight = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-32">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-33" />
  </svg>;